import * as actioncable from "./actioncable";

const subscribeToBoardChannel = actioncable.subscribeToBoardChannel;

export { subscribeToBoardChannel };
